import type { SelectOption } from '@shared/types/form'

// UAE banks supported in the manual add-account flow. Treat this as
// presentational config that mirrors the backend allowlist; when the API
// starts returning the list, swap this for a query.
export const SUPPORTED_BANKS: SelectOption[] = [
  { label: 'Emirates NBD', value: 'emirates-nbd' },
  { label: 'ADIB', value: 'adib' },
  { label: 'FAB', value: 'fab' },
  { label: 'Mashreq', value: 'mashreq' },
]
